import { Component } from '@angular/core';
import { Router, NavigationEnd } from '../../node_modules/@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).gtag('config', 'UA-8309553-46', {'page_path': event.urlAfterRedirects, 'anonymize_ip': true });
      }
    });
  }

  ngOnInit() {
    document.body.classList.add('loaded')
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts